<template>
  <div class="wrapper">
    <div class="md-layout md-gutter image-text-container service-container">
      <div class="md-layout-item md-size-50 mx-auto md-small-size-100">
        <carousel
          :per-page="1"
          loop
          :speed="700"
          autoplay
          :autoplay-timeout="3000"
          :mouse-drag="false"
          navigationEnabled
          navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
          navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
        >
          <slide>
            <div class="carousel-caption">
              <h4>
                <md-icon>location_on</md-icon>
                {{ locationOne }}
              </h4>
            </div>
            <img :src="require('@/assets/img/' + imageOne)" alt="carousel1" />
          </slide>
          <slide>
            <div class="carousel-caption">
              <h4>
                <md-icon>location_on</md-icon>
                {{ locationTwo }}
              </h4>
            </div>
            <img :src="require('@/assets/img/' + imageTwo)" alt="carousel2" />
          </slide>
          <slide>
            <div class="carousel-caption">
              <h4>
                <md-icon>location_on</md-icon>
                {{ locationThree }}
              </h4>
            </div>
            <img :src="require('@/assets/img/' + imageThree)" alt="carousel3" />
          </slide>
        </carousel>
      </div>

      <div
        class="md-layout-item md-medium-size-50 md-small-size-100 md-xsmall-size-100 "
      > 
        <div class='title-content'>
        <img class="service-icon" :src="require('@/assets/img/' + serviceIcon)" alt="carousel3" />
        <h1 class="image-title">{{ title }}</h1>
        </div>
        <hr />
        <p class="image-content">
          {{ content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      carousel1: require("@/assets/img/nature-2.jpg"),
      carousel2: require("@/assets/img/nature.jpg"),
      carousel3: require("@/assets/img/nature-3.jpg")
    };
  },

  props: {
    title: String,
    content: String,
    imageOne: String,
    locationOne: String,
    locationTwo: String,
    locationThree: String,
    imageTwo: String,
    imageThree: String,
    serviceIcon: String
  },
  computed: {}
};
</script>

<style lang="css"></style>
